import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Box,
  CssBaseline
} from "@mui/material";
import WasteTypeActionMenu from "./WasteTypeActionMenu";
import { callApi } from "../../../utils/apiClient";
import { Production_API_ENDPOINTS } from "../../../config/api/apiCallProduction";

const RepulpAddUpdateWT = ({ selectedWT, onClose, loadWasteTypeList }) => {
  const isEdit = !!selectedWT?.id;

  const [formData, setFormData] = useState({
    id: null,
    name: "",
    status: true,
  });

  useEffect(() => {
    if (isEdit) {
      setFormData({
        id: selectedWT.id,
        name: selectedWT.name,
        status: selectedWT.status === true,
      });
    } else {
      resetForm();
    }
  }, [selectedWT]);

  const resetForm = () => {
    setFormData({
      id: null,
      name: "",
      status: true,
    });
  };

  const handleChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ===========================
  // API Calls
  // ===========================
  const handleSave = async () => {
    const payload = {
     p_waste_type_id: formData.id,
      p_waste_type_name: formData.name,
      p_status: formData.status,
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
      p_created_by: localStorage.getItem("userID"),
      p_updated_by: localStorage.getItem("userID"),
    };

    await callApi(
      
      Production_API_ENDPOINTS?.repulpmaster?.wastetypecreate || "/api/repulpmaster/wastetypecreate",
      "POST",
      { "Content-Type": "application/json" },
      payload
    );

    loadWasteTypeList();
    onClose();
  };

  const handleDelete = async () => {
    const payload = {
     p_waste_type_id: formData.id,
      p_waste_type_name: formData.name,
      p_status: formData.status,
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
      p_created_by: localStorage.getItem("userID"),
      p_updated_by: localStorage.getItem("userID"),
      p_id:formData.id,
    };
    await callApi(
      Production_API_ENDPOINTS?.repulpmaster?.wastetypedelete || "/api/repulpmaster/wastetypedelete",
      
      "POST",
      { "Content-Type": "application/json" },
      payload 
    );

    
   
  };

   return (
    <>
      <CssBaseline />

      {/* ===== FULL HEIGHT CONTAINER ===== */}
      <Grid
        container
        direction="column"
        sx={{
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* ===== FIXED / STICKY ACTION MENU ===== */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "#1e1e1e",
            borderBottom: "1px solid #444",
            px: 1,
            py: 0.5,
          }}
        >
          <WasteTypeActionMenu
            isEdit={isEdit}
            onSave={handleSave}
            onDelete={handleDelete}
            onClear={resetForm}
            onExit={onClose}
            saveDisabled={!formData.name}
          />
        </Box>

        {/* ===== SCROLLABLE FORM BODY ===== */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 2,
            py: 2,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Waste Type Name"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formData.status}
                    onChange={handleChange}
                    name="status"
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </>
  );
};

export default RepulpAddUpdateWT;
